import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_message = _resolveComponent("message")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_loader, { task: _ctx.task }, null, 8, ["task"]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(_component_message, { type: "warning" }, {
        default: _withCtx(() => [
          _createTextVNode(" An issue occurred when connecting to " + _toDisplayString(_ctx.platform) + ". ", 1)
        ]),
        _: 1
      }),
      _createVNode(_component_q_btn, {
        label: "Try again",
        color: "primary",
        class: "full-width q-mt-md",
        rounded: "",
        onClick: _ctx.start
      }, null, 8, ["onClick"])
    ], 512), [
      [_vShow, !_ctx.isLoading && !_ctx.sessionId]
    ])
  ]))
}